var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8787 21.8787C23.0503 20.7071 24.9497 20.7071 26.1213 21.8787L48 43.7574L69.8787 21.8787C71.0503 20.7071 72.9497 20.7071 74.1213 21.8787C75.2929 23.0503 75.2929 24.9498 74.1213 26.1213L52.2426 48L74.1213 69.8787C75.2929 71.0503 75.2929 72.9497 74.1213 74.1213C72.9497 75.2929 71.0503 75.2929 69.8787 74.1213L48 52.2426L26.1213 74.1213C24.9497 75.2929 23.0503 75.2929 21.8787 74.1213C20.7071 72.9497 20.7071 71.0503 21.8787 69.8787L43.7574 48L21.8787 26.1213C20.7071 24.9497 20.7071 23.0503 21.8787 21.8787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.fb7768888637347bb94643695f8b952c.svg";
export { ForwardRef as ReactComponent };